import React from 'react'
import { Typography, Box } from '@mui/material'

/**
 * @typedef {object} BasicListItemProps
 * @property {React.ReactNode} label - La etiqueta o clave que se muestra a la izquierda, seguida de dos puntos.
 * @property {React.ReactNode} value - El valor que se muestra a la derecha de la etiqueta.
 */

/**
 * Un componente de presentación simple y reutilizable que muestra una única línea de información
 * en un formato de "etiqueta: valor".
 *
 * Utiliza los componentes `Box` y `Typography` de Material-UI para asegurar una alineación
 * y estilo consistentes. Es el bloque de construcción fundamental para listas de detalles.
 *
 * @component
 * @example
 * <BasicListItem label="Nombre de Usuario" value="jane.doe" />
 * <BasicListItem label="Fecha de Registro" value="20/10/2025" />
 *
 * @param {BasicListItemProps} props - Las props del componente BasicListItem.
 */
export const BasicListItem = ({ label, value }) => {
  return (
    <Box mb={1}>
      <Typography
        display="inline"
        variant="body1"
        color="textSecondary"
        style={{ marginRight: 10 }}
      >
        {label}:
      </Typography>
      <Typography display="inline" variant="body1">
        {value}
      </Typography>
    </Box>
  )
}
